import { useNavigate, useLocation } from "react-router-dom";
import { IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonCardSubtitle, IonIcon } from "@ionic/react";
import { colorPaletteOutline } from "ionicons/icons";
import AppLayout from "@/components/AppLayout";
import AppSeo from "@/components/AppSeo";
import AppBrandingCard from "@/components/AppBrandingCard";

// /app/preferences: the account's preferences hub, built like the admin's —
// a grid of tappable cards, and a segment row in the top bar that opens one
// area in place of the grid. ?segment=branding is the Branding area (saved
// signatures and logos, and the brand colour).
const CARDS = [
  {
    id: "branding",
    title: "Branding",
    icon: colorPaletteOutline,
    to: "/app/preferences?segment=branding",
    text: "Your saved signatures and logos, and the colour used for your top bar and buttons.",
  },
];

const SEGMENTS = [
  { value: "all", label: "All", to: "/app/preferences" },
  { value: "branding", label: "Branding", to: "/app/preferences?segment=branding" },
];

export default function AppPreferences() {
  const navigate = useNavigate();
  const location = useLocation();
  const wanted = new URLSearchParams(location.search).get("segment");
  const segment = SEGMENTS.some((s) => s.value === wanted && s.value !== "all") ? wanted : "all";

  return (
    <AppLayout
      pageTabs={{
        value: segment,
        items: SEGMENTS,
        dropdownOnMobile: true, // a phone folds the tabs into the top bar's dropdown
        // replace, not push: segment hops stay one history entry, so the top
        // bar's back leaves to the page you actually came from
        onChange: (v) => { const s = SEGMENTS.find((x) => x.value === v); if (s) navigate(s.to, { replace: true }); },
      }}
    >
      <AppSeo title="Preferences" description="Your branding and account preferences." path="/app/preferences" />
      <div className="app-preferences" style={{ maxWidth: 1200, margin: "0 auto" }}>
        {segment === "branding" ? (
          <AppBrandingCard />
        ) : (
          <IonGrid className="ion-padding-top">
            <IonRow>
              {CARDS.map((c) => (
                <IonCol key={c.id} size="12" sizeMd="6" sizeLg="4" className="workers-container">
                  <IonCard button className="workers-card pref-card" data-pref={c.id} onClick={() => navigate(c.to, { replace: true })}>
                    <IonCardHeader>
                      <IonCardTitle style={{ display: "flex", alignItems: "center", gap: 16 }}>
                        <IonIcon color="primary" icon={c.icon} style={{ fontSize: 24, flexShrink: 0 }} />
                        {c.title}
                      </IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                      <IonCardSubtitle>{c.text}</IonCardSubtitle>
                    </IonCardContent>
                  </IonCard>
                </IonCol>
              ))}
            </IonRow>
          </IonGrid>
        )}
      </div>
    </AppLayout>
  );
}
